import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastHelper {

  /**
   * Construct helper
   */
  constructor(
    private toastr: ToastrService
  ) { }

  /**
   * Show success message
   * 
   * @param message
   */
  success(message: string) {
    this.toastr.success(message);
  }

  /**
   * Show error message
   * 
   * @param message
   */
  error(message: string) {
    this.toastr.error(message);
  }

  /**
   * Show info message
   * 
   * @param message
   */
  info(message: string) {
    this.toastr.info(message);
  }

  /**
   * Show warning message
   * 
   * @param message
   */
  warning(message: string) {
    this.toastr.warning(message);
  }
}
